import { cva } from 'class-variance-authority';

export type BadgeVariantType = 'error' | 'successful' | 'warning' | 'info' | 'default';

const badgeVariants = cva('flex item-center px-2 rounded pt-1 text-sm', {
    variants: {
        variant: {
            default: '',
            error: 'bg-primary-100 text-primary-500',
            successful: 'bg-green-100 text-green-500',
            warning: 'bg-yellow-100 text-yellow-500',
            info: 'bg-primary-100 text-primary-500'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});

export interface Props {
    label: string;
    variant: BadgeVariantType;
}

const Badge: React.FC<Props> = ({ label, variant }) => {
    return (
        <div className={badgeVariants({ variant })}>
            <span>{label}</span>
        </div>
    );
};

Badge.displayName = 'Badge';

export default Badge;

